import { HTTP } from '../../http-common'

export default {
  state: {
    loadedSiloTypes: []
  },
  getters: {
    loadedSiloTypes (state) {
      return state.loadedSiloTypes
    }
  },
  mutations: {
    setLoadedSiloTypes (state, payload) {
      state.loadedSiloTypes = payload
    },
    createSiloType (state, payload) {
      state.loadedSiloTypes.push(payload)
    },
    updateSiloType (state, payload) {
      state.loadedSiloTypes = state.loadedSiloTypes.map(siloType => siloType.id === payload.id ? payload : siloType)
    },
    removeSiloType (state, id) {
      state.loadedSiloTypes = state.loadedSiloTypes.filter(siloType => {
        return siloType.id !== id
      })
    },
    clearLoadedSiloTypes (state) {
      state.loadedSiloTypes = []
    }
  },
  actions: {
    loadSiloTypes ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedSiloTypes', [])

      return new Promise((resolve, reject) => {
        HTTP.get('silo_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedSiloTypes', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createSiloType ({ commit, getters }, payload) {
      console.log('createSiloType')
      commit('clearError')
      commit('setLoading', true)
      const newSiloType = {
        description: payload.description,
        capacity: payload.capacity
      }
      console.log('newSiloType', newSiloType)
      return new Promise((resolve, reject) => {
        HTTP.post('silo_type.json/', newSiloType)
          .then(result => {
            console.log(result)
            commit('createSiloType', result.data)
            commit('setLoading', false)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setLoading', false)
            commit('setError', err)
            reject(err)
          })
      })
    },
    updateSiloType ({ commit, getters }, payload) {
      console.log('updateSiloType')
      commit('clearError')
      commit('setLoading', true)
      const siloType = {
        description: payload.description,
        capacity: payload.capacity
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`silo_type.json/${payload.id}/`, siloType)
          .then(result => {
            console.log(result)
            commit('updateSiloType', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeSiloType ({ commit }, payload) {
      console.log('removeSiloType')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`silo_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeSiloType', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedSiloTypes ({ commit }) {
      commit('clearLoadedSiloTypes')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/silo_type/index.js